export default {
    env: process.env.REACT_APP_ENV,
    baseUrl: process.env.REACT_APP_BASE_URL,
    productExternalLink: process.env.REACT_APP_PRODUCT_PAGE_URL,
    privacyPolicyExternalLink: process.env.REACT_APP_PRIVACY_POLICY_URL,
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    cooperCompaniesExternalLink: process.env.REACT_APP_COOPER_COMPANIES_URL,
};
